import { medias } from 'assets/styled/tokens';
import styled from 'styled-components';

export const CarouselContainer = styled.div`
  width: 100%;
  height: max-content;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);

  @media screen and (max-width: ${medias.tablet}) {
    margin-top: 20px;
  }
`;

export const SlideItem = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 87/47;

  :hover {
    cursor: pointer;
  }
`;

export const ClickContainer = styled.div`
  height: 100%;
`;
